export default __webpack_public_path__ + "static/media/background.d900dd2c.svg";